import React from "react"
import {Link} from "gatsby"

const linkStyle = {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 700,
    fontSize: "1.2rem",
}

const Navbar = () => {
    return (
        
        <nav style={{paddingBottom: '15px'}}>
                
        <span style={{marginLeft: '20px'}}><Link to="/blog" style={linkStyle}>Writing</Link></span>

        <span style={{marginLeft: '20px'}}><Link to="/projects" style={linkStyle}>Projects & pursuits</Link></span>
        
       </nav>
        
        
    )
}

export default Navbar
